import React from 'react';
import { MapPin, Phone, Instagram, Clock, Zap, Camera, Gift, MessageCircle } from 'lucide-react';
import { transformBg } from '../mock';

const WA_LINK = 'https://wa.me/905544356351?text=Merhaba%20Anlar%20Oto%20Dizayn%2C%20arac%C4%B1m%20i%C3%A7in%20bilgi%20almak%20istiyorum.';

const Contact = () => {
  return (
    <section id="iletisim" className="section" style={{ backgroundColor: 'var(--bg-2)' }}>
      <div className="section-bg" style={{ backgroundImage: `url(${transformBg})`, opacity: 0.05 }} />
      <div className="section-inner">
        <div className="section-head">
          <div className="section-label">İletişim</div>
          <h2 className="section-title">
            Randevu Alın, <br />
            <span className="accent">Fark Görün</span>
          </h2>
        </div>
        <div className="contact-grid">
          <div className="contact-info-card">
            <div className="contact-info-row">
              <div className="contact-info-icon"><MapPin size={18} /></div>
              <div className="contact-info-text">
                <div className="contact-info-title">Oto Sanayi Sitesi</div>
                <div className="contact-info-sub">Ulaşım kolay, kapalı atölye</div>
              </div>
            </div>
            <div className="contact-info-row">
              <div className="contact-info-icon"><Phone size={18} /></div>
              <div className="contact-info-text">
                <a href="tel:+905544356351" className="contact-info-sub" style={{ color: 'var(--text)', fontWeight: 600 }}>+90 (554) 435 63 51</a>
                <div className="contact-info-sub">7/24 WhatsApp desteği</div>
              </div>
            </div>
            <div className="contact-info-row">
              <div className="contact-info-icon"><Instagram size={18} /></div>
              <div className="contact-info-text">
                <a href="https://instagram.com/anlarotodizayn" target="_blank" rel="noreferrer" className="contact-info-sub" style={{ color: 'var(--text)', fontWeight: 600 }}>@anlarotodizayn</a>
                <div className="contact-info-sub">Güncel çalışmalarımız</div>
              </div>
            </div>
            <div className="contact-info-row">
              <div className="contact-info-icon"><Clock size={18} /></div>
              <div className="contact-info-text">
                <div className="contact-info-title">Pzt–Cum 09:00–18:00</div>
                <div className="contact-info-sub">Cumartesi: 09:00–14:00</div>
              </div>
            </div>
            <a href="https://maps.app.goo.gl/62Uzj3mr8" target="_blank" rel="noreferrer" className="btn-secondary map-btn">Büyük Haritada Aç</a>
          </div>

          <div className="contact-cta">
            <h3>Aracınızı Konuşalım</h3>
            <p>Aracınızın fotoğraflarını ve isteklerinizi WhatsApp&apos;tan bize iletin. Ortalama 15 dakika içinde geri dönüş yapalım. Ücretsiz değerlendirme garantili.</p>
            <div className="contact-perks">
              <div className="contact-perk"><span className="icon"><Zap size={14} /></span> Hızlı yanıt (ort. 15 dk)</div>
              <div className="contact-perk"><span className="icon"><Camera size={14} /></span> Fotoğraf gönderebilirsin</div>
              <div className="contact-perk"><span className="icon"><Gift size={14} /></span> Ücretsiz değerlendirme</div>
            </div>
            <a className="whatsapp-btn" href={WA_LINK} target="_blank" rel="noreferrer">
              <MessageCircle size={20} />
              WHATSAPP&apos;TAN MESAJ GÖNDER →
            </a>
            <div className="contact-divider"><span>veya</span></div>
            <div className="contact-actions">
              <a className="contact-action" href="tel:+905544356351">
                <span className="small">Hemen Ara</span>
                <span className="big">+90 554 435 63 51</span>
              </a>
              <a className="contact-action" href="https://instagram.com/anlarotodizayn" target="_blank" rel="noreferrer">
                <span className="small">Instagram</span>
                <span className="big">@anlarotodizayn</span>
              </a>
            </div>
          </div>
        </div>
        <div className="status-bar">
          <span className="status-dot" /> ŞU AN AÇIK · Bugün 18:00&apos;a kadar
        </div>
      </div>
    </section>
  );
};

export default Contact;
